<template>
  <div>
    <v-menu
      v-if="!$vuetify.display.mobile"
      :model-value="inboxDisplayed"
      attach=".menu-attach-element"
      :min-width="menuWidth"
      :max-width="menuWidth"
      :close-on-content-click="false"
      :style="{ top: `${iconSize}px`, left: `${menuNudgeLeft}px` }"
      @update:model-value="onMenuInput"
    >
      <activities-container v-if="inboxDisplayed" />
    </v-menu>
    <message-dialog ref="dialog" v-else :dialog="inboxDisplayed" fullscreen hide-overlay persistent disable-content-padding>
      <template #header>
        <header-mobile :title="$translate('common.notifications')">
          <template #item-left>
            <div class="mobile-header-placeholder" />
          </template>
          <template #item-right>
            <div class="mobile-header-placeholder">
              <portal-target name="notifications-center-header-mobile-action" />
            </div>
          </template>
        </header-mobile>
      </template>
      <template #content>
        <activities-container v-if="inboxDisplayed" ref="activitiesContainer" class="mb-12" />
        <the-bottom-nav />
      </template>
    </message-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "pinia"

import { useAppStateStore } from "@/store/appState.js"

import ActivitiesContainer from "@/components/activities/ActivitiesContainer.vue"

import { usePageScroll } from "@/composables/usePageScroll.js"

export default {
  components: {
    ActivitiesContainer
  },
  setup() {
    const { goTo } = usePageScroll()
    return { goTo }
  },
  data() {
    return {
      shouldShowInboxOnReturn: false,
      menuWidth: 380,
      iconSize: 64
    }
  },
  computed: {
    ...mapGetters(useAppStateStore, ["mobileBottomBarHeight", "inboxDisplayed"]),
    menuNudgeLeft() {
      const triangleOffset = 80
      return -1 * (this.menuWidth / 2 + triangleOffset)
    }
  },
  watch: {
    $route() {
      if (this.$vuetify.display.mobile) {
        this.setInboxDisplayed(false)
      }
    }
  },
  created() {
    this.$eventBus.$on("inbox-button-mobile-click", this.onMobileButtonClick)
    this.$eventBus.$on("activity-item-click", this.hideInboxAndShowItWhenReturnOnMobile)
    this.$eventBus.$on("router-history-back", this.showInboxOnReturn)
    window.addEventListener("popstate", this.showInboxOnReturn)
  },
  beforeUnmount() {
    this.$eventBus.$off("inbox-button-mobile-click", this.onMobileButtonClick)
    this.$eventBus.$off("activity-item-click", this.hideInboxAndShowItWhenReturnOnMobile)
    this.$eventBus.$off("router-history-back", this.showInboxOnReturn)
    window.removeEventListener("popstate", this.showInboxOnReturn)
  },
  methods: {
    ...mapActions(useAppStateStore, ["setInboxDisplayed"]),
    showInboxOnReturn() {
      if (this.$vuetify.display.mobile && this.shouldShowInboxOnReturn) {
        // Make sure that it's called after $route watcher that sets inbox to false
        setTimeout(() => {
          this.setInboxDisplayed(true)
          this.shouldShowInboxOnReturn = false
        })
      }
    },
    hideInboxAndShowItWhenReturnOnMobile() {
      this.setInboxDisplayed(false)
      this.shouldShowInboxOnReturn = this.$vuetify.display.mobile
    },
    onMenuInput(value) {
      if (!value) {
        this.setInboxDisplayed(false)
      }
    },
    async onMobileButtonClick(wasAlreadyShown) {
      if (wasAlreadyShown) {
        await this.$nextTick()
        this.$refs.activitiesContainer.fetchActivities()
        this.goTo(0, { duration: 300, container: this.$refs.dialog.getFillAreaRef().$el })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-menu {
  :deep(.v-overlay__content) {
    contain: initial;
    overflow: visible;
    border-radius: var(--rounded-app);
    box-shadow: var(--shadow-4);
    text-indent: 0;
    cursor: auto;

    &::before {
      content: "";
      position: absolute;
      right: 64px;
      width: 0;
      height: 0;
      border-bottom: 10px solid;
      border-left: 15px solid transparent;
      border-right: 15px solid transparent;
      top: -10px;
    }

    .pull-to-refresh-content {
      max-height: calc(100vh - 200px);
    }
  }
}
</style>
